/**
 * Application route paths.
 * Centralized route constants to avoid magic strings throughout the app.
 */
export const ROUTES = {
  DASHBOARD: '/',
  SEND: '/send',
  RECEIVE: '/receive',
  SETTINGS: '/settings',
  SETTINGS_SECURITY: '/settings/security',
  BACKUP: '/backup',
  FORGOT_PIN: '/forgot-pin',
  SETTINGS_MINTS: '/settings/mints',
  BRIDGE: '/bridge',
  CONNECTIONS: '/connections',
  CONNECTIONS_ADD: '/connections/add',
  CONNECTION_DETAIL: '/connections/:connectionId',
  HISTORY: '/history',
  CONTACTS: '/contacts',
  CONTACT_DETAIL: '/contacts/:contactId',
  VANITY_ADDRESS: '/settings/vanity-address',
  WALLETS: '/wallets',
  WALLETS_ECASH: '/wallets/ecash',
  WALLETS_ECASH_MINT: '/wallets/ecash/mints/:mintUrl',
  WALLETS_LIGHTNING: '/wallets/lightning/:connectionId',
} as const;

/** Union type of all valid route paths */
export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
